import { c as _c } from "react/compiler-runtime";
import React from 'react';
export default function Loading() {
  const $ = _c(15);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className={"\n        flex min-h-max w-full flex-col justify-between gap-4 p-16\n        lg:w-1/4\n      "}>{Array(2).fill("").map(_temp)}</div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className={"\n          h-10 w-48 rounded-full bg-spindle\n          xl:w-64\n        "} />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex flex-col gap-y-4">{[...Array(13).keys()].map(_temp2)}</div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="flex flex-col gap-y-4"><div className={"\n                  h-32 w-4 rounded-lg bg-spindle\n                  md:w-8\n                  xl:w-10\n                "} /><div className={"\n                  h-2 w-4 rounded-lg bg-spindle\n                  md:w-8\n                  lg:h-5\n                  xl:w-10\n                "} /></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="flex flex-col gap-y-4"><div className={"\n                  h-16 w-4 rounded-lg bg-spindle\n                  md:w-8\n                  xl:w-10\n                "} /><div className={"\n                  h-2 w-4 rounded-lg bg-spindle\n                  md:w-8\n                  lg:h-5\n                  xl:w-10\n                "} /></div>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="flex flex-col gap-y-4"><div className={"\n                  h-0 w-4 rounded-lg bg-spindle\n                  md:w-8\n                  xl:w-10\n                "} /><div className={"\n                  h-2 w-4 rounded-lg bg-spindle\n                  md:w-8\n                  lg:h-5\n                  xl:w-10\n                "} /></div>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="flex flex-col gap-y-4"><div className={"\n                  h-2 w-4 rounded-lg bg-spindle\n                  md:w-8\n                  xl:w-10\n                "} /><div className={"\n                  h-2 w-4 rounded-lg bg-spindle\n                  md:w-8\n                  lg:h-5\n                  xl:w-10\n                "} /></div>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="flex flex-col gap-y-4"><div className={"\n                  h-48 w-4 rounded-lg bg-spindle\n                  md:w-8\n                  lg:h-96\n                  xl:w-10\n                "} /><div className={"\n                  h-2 w-4 rounded-lg bg-spindle\n                  md:w-8\n                  lg:h-5\n                  xl:w-10\n                "} /></div>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="flex flex-col gap-y-4"><div className={"\n                  h-56 w-4 rounded-lg bg-spindle\n                  md:w-8\n                  xl:w-10\n                "} /><div className={"\n                  h-2 w-4 rounded-lg bg-spindle\n                  md:w-8\n                  lg:h-5\n                  xl:w-10\n                "} /></div>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="flex flex-col gap-y-4"><div className={"\n                  h-4 w-4 rounded-lg bg-spindle\n                  md:w-8\n                  xl:w-10\n                "} /><div className={"\n                  h-2 w-4 rounded-lg bg-spindle\n                  md:w-8\n                  lg:h-5\n                  xl:w-10\n                "} /></div>;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div className="flex flex-col gap-y-4"><div className={"\n                  h-24 w-4 rounded-lg bg-spindle\n                  md:w-8\n                  xl:w-10\n                "} /><div className={"\n                  h-2 w-4 rounded-lg bg-spindle\n                  md:w-8\n                  lg:h-5\n                  xl:w-10\n                "} /></div>;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <div className="flex flex-col gap-y-4"><div className={"\n                  h-48 w-4 rounded-lg bg-spindle\n                  md:w-8\n                  lg:h-80\n                  xl:w-10\n                "} /><div className={"\n                  h-2 w-4 rounded-lg bg-spindle\n                  md:w-8\n                  lg:h-5\n                  xl:w-10\n                "} /></div>;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <div className="flex flex-col gap-y-4"><div className={"\n                  h-32 w-4 rounded-lg bg-spindle\n                  md:w-8\n                  lg:h-48\n                  xl:w-10\n                "} /><div className={"\n                  h-2 w-4 rounded-lg bg-spindle\n                  md:w-8\n                  lg:h-5\n                  xl:w-10\n                "} /></div>;
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  let t13;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <div className="flex flex-col gap-y-4"><div className={"\n                  h-32 w-4 rounded-lg bg-spindle\n                  md:w-8\n                  xl:w-10\n                "} /><div className={"\n                  h-2 w-4 rounded-lg bg-spindle\n                  md:w-8\n                  lg:h-5\n                  xl:w-10\n                "} /></div>;
    $[13] = t13;
  } else {
    t13 = $[13];
  }
  let t14;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <div className={"\n      flex w-full flex-col\n      lg:flex-row-reverse\n    "}>{t0}<div className={"\n        mt-12 flex w-full animate-pulse flex-col gap-x-4\n        lg:w-3/4\n      "}>{t1}<div className="mt-12 flex flex-col"><div className={"\n            flex gap-x-4\n            md:gap-x-6\n            xl:gap-x-16\n          "}>{t2}<div className={"\n              flex items-end gap-x-4\n              md:gap-x-6\n              xl:gap-x-16\n            "}>{t3}{t4}{t5}{t6}{t7}{t8}{t9}{t10}{t11}{t12}{t13}<div className="flex flex-col gap-y-4"><div className={"\n                  h-32 w-4 rounded-lg bg-spindle\n                  md:w-8\n                  xl:w-10\n                "} /><div className={"\n                  h-2 w-4 rounded-lg bg-spindle\n                  md:w-8\n                  lg:h-5\n                  xl:w-10\n                "} /></div></div></div></div></div></div>;
    $[14] = t14;
  } else {
    t14 = $[14];
  }
  return t14;
}
function _temp2(v) {
  return <div key={`skeleton.axis.${v}`} className={"\n                    h-2 w-4 rounded-lg bg-spindle\n                    md:w-8\n                    lg:h-5\n                    xl:w-10\n                  "} />;
}
function _temp(_v, idx) {
  return <div key={`stat.placeholder.${idx}`} className="w-full rounded-md bg-smoke p-4"><div className="flex w-full animate-pulse flex-col gap-y-4"><div className="flex"><div className="flex w-full flex-col gap-y-6"><div className={"\n                      md:64\n                      h-6 w-48 rounded-full bg-spindle\n                    "} /><div className={"\n                      md:48\n                      h-16 w-32 rounded-lg bg-spindle\n                    "} /></div><div className="flex w-full flex-col items-end gap-y-16"><div className="h-16 w-16 rounded-full bg-spindle" /><div className={"\n                      h-6 w-24 rounded-full bg-spindle\n                      md:w-40\n                    "} /></div></div></div></div>;
}